import ColorsStyles from '@Styles/colors.scss';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';
import React from 'react';
import LoginHeader from './LoginHeader';
import Styles from './LoginView.scss';

const LoginView = () => {
    const { loginWithRedirect } = useAuth0();
    return (
        <div>
            <LoginHeader />
            <div className={Styles.outerContainer}>
                <div className={Styles.innerContainer}>
                    <span className={Styles.title}>Welcome to Koru</span>
                    <div className={Styles.divider} />
                    <div className={Styles.formContainer}>
                        <Button
                            color="primary"
                            variant="contained"
                            id="login-button"
                            onClick={() =>
                                loginWithRedirect({
                                    authorizationParams: {
                                        audience: process.env.AUTH0_AUDIENCE,
                                    },
                                })
                            }
                            sx={{
                                backgroundColor:
                                    ColorsStyles.ikeSecondaryDarkBlue,
                                fontWeight: '400',
                                fontSize: '14px',
                                lineHeight: '17px',
                                padding: '.6rem 1rem',
                                textTransform: 'uppercase',
                                '&:hover': {
                                    backgroundColor:
                                        ColorsStyles.ikeSecondaryLightBlue,
                                },
                            }}
                        >
                            Login with Ike Id
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginView;
